<div id="map-container">
	<div class="c-portlet u-bg-main u-shadow-mini" (window:resize)="onResize($event)">
		<app-loader [showLoader]="showLoad"></app-loader>
		<div
			class="analytics-campaign-charts-header c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini"
		>
			<div class="o-stack__cell">
				<h5>Map</h5>
			</div>
		</div>
		<div class="c-portlet__content pos-relative">
			<div>
				<div class="map-wrapper">
					<div id="map"></div>
					<div id="geofence-disclaimer" class="geofence-disclaimer">
						<div class="geofence-disclaimer-section">
							<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
							<span class="geofence-disclaimer-text">Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected campaign.</span>
						</div>
					</div>
					<div
						class="map-region-container"
						*ngIf="polygonLayerDetails && showPolygonLayerDetailsFlag && !showGeofenceCenterDetailsFlag"
					>
						<div class="map-region-dmographic-title margin-10pb">{{ polygonLayerDetails.regionName }}</div>
						<div class="map-region-detail-container">
							<span class="map-region-dmographic-title">{{ polygonLayerDetails.region }}, </span>
							<span class="map-region-dmographic-title">Postal Code: </span>
							<span class="map-region-dmographic-value">{{ polygonLayerDetails.zip }}</span>
						</div>
						<div class="map-region-detail-container">
							<span class="map-region-dmographic-title map-region-population-title">Population:</span>
							<span class="map-region-dmographic-value">{{ polygonLayerDetails.population }}</span>
						</div>
						<div class="map-region-lift-detail-container" *ngIf="polygonLayerDetails.showLift">
							<!-- Show Lift -->
							<div class="map-region-lift" *ngIf="polygonLayerDetails.avgLift">
								Lift: {{ polygonLayerDetails.avgLift }}x
							</div>
							<div class="map-region-dmographic-value" *ngIf="!polygonLayerDetails.avgLift">
								Additional data required to calculate Lift
							</div>

							<!-- Show Average Home Value -->
							<div class="map-region-dmographic-container margin-20pt">
								<span class="map-region-dmographic-title"> Avg. home value: </span>
								<span *ngIf="polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value"
									>${{ polygonLayerDetails.avgHomeValue | formatNumber }}</span
								>
								<span *ngIf="!polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value">--</span>
							</div>

							<!-- Show Average Median Age -->
							<div class="map-region-dmographic-container">
								<span class="map-region-dmographic-title"> Median age: </span>
								<span *ngIf="polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">{{
									polygonLayerDetails.avgMedianAge
								}}</span>
								<span *ngIf="!polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">--</span>
							</div>

							<!-- Show Average Income -->
							<div class="map-region-dmographic-container">
								<span class="map-region-dmographic-title"> Avg. income # per household: </span>
								<span *ngIf="polygonLayerDetails.avgIncome" class="map-region-dmographic-value"
									>${{ polygonLayerDetails.avgIncome | formatNumber }}</span
								>
								<span *ngIf="!polygonLayerDetails.avgIncome" class="map-region-dmographic-value">--</span>
							</div>
						</div>
					</div>
					<div class="map-details-container">
						<div class="details-map-container">
							<div id="minimap"></div>
						</div>
						<div class="map-details-wrapper">
							<div class="r4-geofence-center">
								<div class="map-region-dmographic-title map-geofencedetails-name">
									{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}
								</div>
							</div>
							<div class="map-region-detail-container r4-map-region-detail-container">
								<span class="map-region-dmographic-value r4-map-region-dmographic-value"
									>Impressions: {{ geofenceCenterDetails ? geofenceCenterDetails.total_impression_sum : '' }}</span
								><br />
								<span class="map-region-dmographic-value"
									>CTR: {{ geofenceCenterDetails ? geofenceCenterDetails.click_through_rate : '' }}% |</span
								>
								<span class="map-region-dmographic-value"
									>Clicks: {{ geofenceCenterDetails ? geofenceCenterDetails.total_click_sum : '' }} </span
								><br />
								<span class="map-region-dmographic-value"
									>Android: {{ geofenceCenterDetails ? geofenceCenterDetails.total_android : '' }}% |</span
								>
								<span class="map-region-dmographic-value"
									>Apple: {{ geofenceCenterDetails ? geofenceCenterDetails.total_ios : '' }}%
								</span>
							</div>
						</div>
					</div>
					<div class="zoom-options-container">
						<div class="zoom-icon" (click)="zoomIn()">
							<i class="fa fa-plus" aria-hidden="true"></i>
						</div>
						<div class="zoom-icon zoom-out-icon" (click)="zoomOut()">
							<i class="fa fa-minus" aria-hidden="true"></i>
						</div>
					</div>
				</div>
				<!--Legend starts here-->
				<!-- <div class="map-products-container">
          <h5 class="map-products-title">Click on products to see coverage:</h5>
          <div class="map-products-list">
            <div class="map-product-item" *ngFor="let legendItem of mapObj?.legend" [ngClass]="{'map-product-item-selected': legendItem.isSelected, 'disable-button': legendItem.isDisabled}"
              (click)="selectedProductDetails(legendItem)">
              {{legendItem.productName}}
            </div>
          </div>
        </div> -->
				<!--Legend ends here-->
			</div>
			<div class="no-data-container" *ngIf="noData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
